import { ActionsAccount } from './Types';
import ServiceAccount from '../../Services/ServiceAccount';
import { IPageOptions } from '../../Models/Common';
import { IAccountForm } from '../../Models/Account';
import { Producer } from '../../Models/Report';
import { createActionChecking } from '../Session/Actions';
import { EStatusRequest } from '../../Reducers/Session';

const service = new ServiceAccount();

const actionRequest = {
	type: ActionsAccount.REQUEST_ACCOUNT
};

export const createActionFetchAccount = (id: number) => {
	return (dispatch: any) => {
		dispatch(actionRequest);
		service
			.fetch(id)
			.then(async r => {
				if (!r.ok) {
					dispatch({
						type: ActionsAccount.ERROR_ACCOUNT,
						payload: await r.json()
					});
					dispatch(actionRequest);
					return
				}
				const account = await r.json();
				const branchs = await (await service.getBranch(account.id)).json();
				const first = branchs || branchs.length > 0 ? branchs[0] : undefined;
				if (!first || 'Status' in first) {
					account.producers = [];
					account.producersList = [];
				} else {
					account.producers = Producer.transform(
						branchs,
						-1,
						() => {},
						undefined,
						false
					);
					account.producersList = branchs;
				}
				dispatch({
					type: ActionsAccount.FETCH_ACCOUNT,
					payload: account
				});
				dispatch(actionRequest);
			})
			.catch(e => {
				dispatch(actionRequest);
				dispatch({
					type: ActionsAccount.ERROR_ACCOUNT,
					payload: e.toString()
				});
			});
	};
};

export const createActionfetchAccounts = (
	options: IPageOptions,
	idProfile?: number,
	search?: string,
	order?: string
) => {
	return (dispatch: any) => {
		dispatch(actionRequest);
		service
			.fetchPage(
				options.page,
				options.size,
				idProfile,
				order,
				undefined,
				search
			)
			.then(async r => {
				if (r.status === 403) {
					dispatch(actionRequest);
					dispatch(createActionChecking());
				} else {
					const res = await r.json();
					if (!r.ok) {
						dispatch({
							type: ActionsAccount.ERROR_ACCOUNT,
							payload: res
						});
					} else {
						dispatch({
							type: ActionsAccount.FETCH_ACCOUNTS,
							payload: res
						});
					}
					dispatch(actionRequest);
				}
			})
			.catch(e => {
				dispatch(actionRequest);
				dispatch({
					type: ActionsAccount.ERROR_ACCOUNT,
					payload: e.toString()
				});
			});
	};
};

export const createActionCleanAccount = () => ({
	type: ActionsAccount.CLEAN_CURRENT_ACCOUNT
});

export const createActionCleanAccountStatus = () => ({
	type: ActionsAccount.CLEAN_STATUS_ACCOUNT
});

export const createActionStatusAccount = (status: EStatusRequest) => ({
	type: ActionsAccount.STATUS_REQUEST_ACCOUNT,
	payload: status
});

export const createActionCreateAccount = (data: IAccountForm, id?: number) => {
	return (dispatch: any, state: any) => {
		dispatch(actionRequest);
		dispatch(createActionStatusAccount(EStatusRequest.PROCESS));
		const fetch = !id ? service.create(data) : service.edit(data, id);
		fetch
			.then(async r => {
				if (r.ok) {
					const res = await r.json();
					dispatch({
						type: ActionsAccount.CREATE_ACCOUNT,
						payload: res
					});
					dispatch(actionRequest);
					dispatch(createActionStatusAccount(EStatusRequest.COMPLETE));
					dispatch(createActionfetchAccounts({ page: 0, size: 5 }));
				} else {
					const res = await r.json();
					dispatch(actionRequest);
					dispatch({
						type: ActionsAccount.ERROR_ACCOUNT,
						payload: res
					});
					dispatch(createActionStatusAccount(EStatusRequest.FAIL));
				}
			})
			.catch(e => {
				dispatch(actionRequest);
				dispatch({
					type: ActionsAccount.ERROR_ACCOUNT,
					payload: e.toString()
				});
				dispatch(createActionStatusAccount(EStatusRequest.FAIL));
			});
	};
};

export const createActionDelete = (id: number) => {
	return (dispatch: any) => {
		dispatch(actionRequest);
		service
			.delete(id)
			.then(async res => {
				if (res.ok) {
					dispatch({
						type: ActionsAccount.DELETE_ACCOUNT,
						payload: id
					});
					dispatch(createActionfetchAccounts({ page: 0, size: 5 }));
				} else {
					dispatch({
						type: ActionsAccount.ERROR_ACCOUNT,
						payload: 'Error borrando'
					});
				}
				dispatch(actionRequest);
			})
			.catch(e => {
				dispatch(actionRequest);
				dispatch({
					type: ActionsAccount.ERROR_ACCOUNT,
					payload: e.toString()
				});
				dispatch({
					type: ActionsAccount.STATUS_REQUEST_ACCOUNT,
					payload: EStatusRequest.FAIL
				});
			});
	};
};
